<template>
  <div>
    <a
      href="#"
      @click.prevent="doButtonAction"
      target="_self"
      class="readmore readmore__linkBox"
      :class="{
        'readmore__linkBox--arrow-left': arrowLeft,
        'readmore__linkBox--arrow-down': arrowDown,
        'readmore__linkBox--arrow-up': arrowUp,
        'readmore__linkBox--disabled': isDisabled,
        'readmore__linkBox--muted': muted,
        'readmore__linkBox--green': colour === 'green',
        'readmore__linkBox--red': colour === 'red',
      }"
    >
      <p>{{ title }}</p>
      <span></span>
    </a>
    <popup-modal v-if="showModal" :heading="confirmationHeading" :message="confirmationMessage" @close="handleCloseModal" @confirm="handleConfirm" />
  </div>
</template>

<script>
import PopupModal from "./PopupModal.vue";
import { mapFields } from "vuex-map-fields";

export default {
  components: { PopupModal },
  data() {
    return {
      showModal: false,
      actionToConfirm: null,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    arrowLeft: {
      type: Boolean,
      default: false,
    },
    arrowDown: {
      type: Boolean,
      default: false,
    },
    arrowUp: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonAction: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    muted: {
      type: Boolean,
    },
    viewName: {
      type: String,
    },
    colour: {
      type: String,
    },
    requireConfirmation: {
      type: Boolean,
      default: false,
    },
    confirmationHeading: {
      type: String,
      default: "",
    },
    confirmationMessage: {
      type: String,
      default: "",
    },
    nextView: {
      type: String, // TODO: maybe look to change the direct action with this
      default: null,
    },
  },
  methods: {
    changeSliderByName() {
      this.screenList.forEach((screen, index) => {
        if (screen.component === this.viewName) {
          this.currentScreenIndex = index;
          this.navigationDirection = "next";
        }
      });
    },
    doButtonAction() {
      if (this.isDisabled) {
        return;
      } else {
        if (this.requireConfirmation) {
          this.showModal = true;
          this.actionToConfirm = this.buttonAction;
          return;
        }
        this.executeAction(this.buttonAction);
      }
    },

    executeAction(action) {
      this.disabledAnimationBackground = false;

      if (this.buttonAction == "direct") {
        this.disabledAnimationBackground = true;
        this.changeSliderByName();
      } else if (this.buttonAction === "next") {
        this.navigationDirection = "next";
        this.currentScreenIndex++;
      } else if (this.buttonAction === "prev") {
        this.navigationDirection = "back";
        this.currentScreenIndex--;
      } else if (this.buttonAction === "submit") {
        if (this.nextView !== null) {
          this.$store.dispatch("submit", { nextView: this.nextView });
        } else {
          this.$store.dispatch("submit");
        }
        // this.navigationDirection = "next";
      } else if (this.buttonAction === "questionYes") {
        this.submissionData.questionAnswer = true;
        this.navigationDirection = "next";
        this.currentScreenIndex++;
      } else if (this.buttonAction === "questionNo") {
        this.submissionData.questionAnswer = false;
        this.navigationDirection = "next";
        this.currentScreenIndex++;
      } else if (this.buttonAction === "reset") {
        this.disabledAnimationBackground = true;
        this.navigationDirection = "back";
        this.$store.commit("resetTool");
      } else {
        console.error("Unknown button action: " + this.buttonAction);
      }
    },

    handleCloseModal() {
      this.showModal = false;
    },

    handleConfirm() {
      this.showModal = false;
      if (this.actionToConfirm) {
        this.executeAction(this.actionToConfirm);
        this.actionToConfirm = null;
      }
    },
  },
  computed: {
    ...mapFields(["currentScreenIndex", "screenList", "navigationDirection", "submissionData", "isTransitioning", "disabledAnimationBackground"]),
    isDisabled() {
      return this.disabled || this.isTransitioning;
    },
  },
};
</script>
